import {
  FETCH_NOTIFICATIONS_START,
  FETCH_NOTIFICATIONS_COMPLETE,
  FETCH_NOTIFICATIONS_ERROR,
  MARK_NOTIFICATION_READ_START,
  MARK_NOTIFICATION_READ_COMPLETE,
  MARK_NOTIFICATION_READ_ERROR,
  MARK_ALL_NOTIFICATIONS_READ_START,
  MARK_ALL_NOTIFICATIONS_READ_COMPLETE,
  MARK_ALL_NOTIFICATIONS_READ_ERROR,
  FETCH_NOTIFICATION_COUNT_START,
  FETCH_NOTIFICATION_COUNT_COMPLETE,
  FETCH_NOTIFICATION_COUNT_ERROR,
} from './actions';
import { LOGOUT } from '../login/actions';

let initialState = {
  notifications: [],
  notificationCount: 0,
  unreadCount: 0,
  isFetchNotificationsStarted: false,
  fetchNotificationsError: undefined,
  isMarkNotificationReadStarted: false,
  markNotificationReadError: undefined,
  isMarkAllNotificationsReadStarted: false,
  markAllNotificationsReadError: undefined,
  isFetchNotificationCountStarted: false,
  fetchNotificationCountError: undefined,
};

const reducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case FETCH_NOTIFICATIONS_START:
      return {
        ...state,
        isFetchNotificationsStarted: true,
        fetchNotificationsError: undefined,
      };
    case FETCH_NOTIFICATIONS_COMPLETE:
      return {
        ...state,
        notifications: payload.data || [],
        notificationCount: payload.count || 0,
        isFetchNotificationsStarted: false,
        fetchNotificationsError: undefined,
      };
    case FETCH_NOTIFICATIONS_ERROR:
      return {
        ...state,
        fetchNotificationsError: payload.error,
        isFetchNotificationsStarted: false,
        notifications: [],
      };
    case MARK_NOTIFICATION_READ_START:
      return {
        ...state,
        isMarkNotificationReadStarted: true,
        markNotificationReadError: undefined,
      };
    case MARK_NOTIFICATION_READ_COMPLETE:
      const updatedNotifications = state.notifications.map((notification) =>
        notification.id === payload.notificationId
          ? { ...notification, isRead: true }
          : notification
      );
      return {
        ...state,
        notifications: updatedNotifications,
        unreadCount: Math.max(0, state.unreadCount - 1),
        isMarkNotificationReadStarted: false,
        markNotificationReadError: undefined,
      };
    case MARK_NOTIFICATION_READ_ERROR:
      return {
        ...state,
        markNotificationReadError: payload.error,
        isMarkNotificationReadStarted: false,
      };
    case MARK_ALL_NOTIFICATIONS_READ_START:
      return {
        ...state,
        isMarkAllNotificationsReadStarted: true,
        markAllNotificationsReadError: undefined,
      };
    case MARK_ALL_NOTIFICATIONS_READ_COMPLETE:
      const allReadNotifications = state.notifications.map((notification) => ({
        ...notification,
        isRead: true,
      }));
      return {
        ...state,
        notifications: allReadNotifications,
        unreadCount: 0,
        isMarkAllNotificationsReadStarted: false,
        markAllNotificationsReadError: undefined,
      };
    case MARK_ALL_NOTIFICATIONS_READ_ERROR:
      return {
        ...state,
        markAllNotificationsReadError: payload.error,
        isMarkAllNotificationsReadStarted: false,
      };
    case FETCH_NOTIFICATION_COUNT_START:
      return {
        ...state,
        isFetchNotificationCountStarted: true,
        fetchNotificationCountError: undefined,
      };
    case FETCH_NOTIFICATION_COUNT_COMPLETE:
      return {
        ...state,
        unreadCount: payload.unreadCount || 0,
        isFetchNotificationCountStarted: false,
        fetchNotificationCountError: undefined,
      };
    case FETCH_NOTIFICATION_COUNT_ERROR:
      return {
        ...state,
        fetchNotificationCountError: payload.error,
        isFetchNotificationCountStarted: false,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;

